'use strict';

import Vue from 'vue/dist/vue.common.js';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// Components
import SearchForm from '../components/database-search/search-form';
import Results from '../components/database-search/results';
import ErrorMessage from '../components/database-search/error-message';

// Vuex Store
import store from '../vuex/store';

// const selector = '.DatabaseSearch';
const router = new VueRouter({
  mode: 'history'
});

let DatabaseSearch = Vue.extend({
  store,
  router,
  components: {
    SearchForm,
    Results,
    ErrorMessage
  },
  computed: {
  	errorMessage () { return this.$store.state.databaseSearch.errorMessage }
  },
});

export default DatabaseSearch;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/database-search.js